import React, { useState, useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Cropper from 'react-easy-crop';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import uploadIcon from '../../../assets/Imagess/upload-icon.svg';
import zoomIcon from './zoom.svg';
import styles from './UploadImage.module.scss';
import Buttons from '../Buttons/Buttons';

const UploadImage = ({ onCropImage, setFieldValue, value }) => {
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [initialValue, setInitialValue] = useState(value || null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setCropModalOpen(true);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = useCallback(async () => {
    const canvas = document.createElement('canvas');
    const image = new Image();
    image.src = selectedImage;

    await new Promise((resolve) => {
      image.onload = resolve;
    });

    const { width, height, x, y } = croppedAreaPixels;

    const outputWidth = 647;
    const outputHeight = 690;

    canvas.width = outputWidth;
    canvas.height = outputHeight;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, x, y, width, height, 0, 0, outputWidth, outputHeight);

    canvas.toBlob((blob) => {
      const croppedBlob = new File([blob], 'cropped-image.jpg', {
        type: 'image/jpeg',
      });
      const croppedImageURL = URL.createObjectURL(blob);
      setCroppedImage(croppedImageURL);
      setFieldValue && setFieldValue('image', croppedBlob);
      onCropImage && onCropImage(croppedBlob);
      setCropModalOpen(false);
    }, 'image/jpeg');
  }, [croppedAreaPixels, selectedImage, setFieldValue, onCropImage]);

  useEffect(() => {
    if (value) setInitialValue(value);
  }, [value]);

  return (
    <>
      <div
        className={styles['upload-container']}
        onClick={() => {
          if (fileInputRef.current) fileInputRef.current.value = '';
          fileInputRef.current.click();
        }}
      >
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleImageUpload}
        />
        {croppedImage || initialValue ? (
          <div className={styles['image-container']}>
            <img
              className={styles['uploaded-image']}
              src={croppedImage || initialValue}
              alt="Uploaded"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = noImageFound;
              }}
            />
            <button
              className={styles['delete-button']}
              onClick={(e) => {
                e.stopPropagation();
                setCroppedImage(null);
                setInitialValue(null);
                setFieldValue && setFieldValue('image', null);
              }}
              title="حذف الصورة"
            >
              ✕
            </button>
          </div>
        ) : (
          <div className={styles['upload-icon-container']}>
            <img
              className={styles['upload-icon']}
              src={uploadIcon}
              alt="Upload Icon"
            />
            <p className={styles['select-image']}>حدد صورة لتحميلها</p>
            <div>
              <p className={styles['select-sizes']}>
                حجم الصورة: العرض: 647px الارتفاع: 690px
              </p>
            </div>
          </div>
        )}
      </div>

      {cropModalOpen &&
        ReactDOM.createPortal(
          <div className={styles['modal-container']}>
            <div className={styles['modal-content']}>
              <h2>قص الصورة</h2>
              <div className={styles['crop-container']}>
                <Cropper
                  image={selectedImage}
                  crop={crop}
                  zoom={zoom}
                  aspect={3}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                  minZoom={1}
                  maxZoom={3}
                  cropSize={{ width: 500, height: 550 }}
                />
              </div>

              <div className={styles['modal-actions']}>
                <div className={styles['controls']}>
                  <p>تكبير</p>
                  <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={(e) => setZoom(e.target.value)}
                    className={styles['zoom-range']}
                  />
                  <img
                    className={styles['upload-icon']}
                    src={zoomIcon}
                    alt="zoom Icon"
                  />
                </div>
                <div className={styles.buttons}>
                  <Buttons
                    text="حفظ"
                    color="#0DA06E"
                    handleOnClick={handleCrop}
                    rounded
                  />
                  <Buttons
                    text="إلغاء"
                    color="#D9D9D9"
                    handleOnClick={() => setCropModalOpen(false)}
                    rounded
                  />
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default UploadImage;
